import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-bus',
  templateUrl: './bus.component.html',
  styleUrls: ['./bus.component.css']
})
export class BusComponent implements OnInit {

  countryList = [];
  city = [];
  cityList = [];

  model = {
    'table_name': 'bus', 'bus_id': '0', 'bus_no': '', 'seats_num': '', 'city_id': '',
    'country_id': '', 'bus_driver1': '', 'driver1_mobile': '', 'bus_driver2': '', 'driver2_mobile': '',
    'comment': ''
  };

  Success_Msg; Error_Msg; Bus_No_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<BusComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Bus_No_Msg').subscribe((res: string) => {
      this.Bus_No_Msg = res;
    });

  }

  ngOnInit() {
    if (this.dialog_data != null)
      this.model = this.dialog_data;

    let query = this.queryList.all_country;
    let obj2 = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj2)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.countryList = data.data['list'];
      });

    query = this.queryList.all_city;
    obj2 = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj2)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.city = data.data['list'];
        if (this.dialog_data != null)
          this.getCity();
      });
  }

  getCity() {
    this.cityList = [];
    this.city.forEach(element => {
      if (element.country_id == this.model['country_id'])
        this.cityList.push(element);
    });
  }

  add() {
    if (this.model['bus_no'] != '') {
      let values = [];
      values.push(this.model);

      let obj;
      if (this.model['bus_id'] == '0')
        obj = { cmd: 'add', values: values };
      else {
        let where = [{ 'bus_id': this.model['bus_id'] }];
        obj = { cmd: 'update', values: values, where: where };
      }
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.dialog_data = {
              'status': data.status['type']
            };
            this.dialogRef.close(this.dialog_data);
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
    else if (this.model['bus_no'] == '') {
      alert(this.Bus_No_Msg);
    }
  }

  cancel() {
    this.dialogRef.close(this.dialog_data);
  }


}
